// extracted by mini-css-extract-plugin
export var closed = "_b9-1";
export var resizer = "_b9-0";